import { FollowersPanelContext } from '../../typedContexts'
import { FollowersPanel } from '../../components/item/FollowersMultiplePanel'
import { type ReactNode, useCallback, useMemo, useState } from 'react'

export const FollowersPanelSingleton = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)
  const [onAddFollower, setOnAddFollower] = useState<((newFollower: string) => void) | null>(null)
  const [project, setProject] = useState<any>(null)
  const contextValue = useMemo(
    () => ({
      openPanel: (onAddFollower: (newFollower: string) => void, project: any) => {
        setOpen(true)
        setOnAddFollower(() => onAddFollower)
        setProject(project)
      },
    }),
    []
  )
  const handleDismiss = useCallback(() => {
    setOpen(false)
    setOnAddFollower(null)
  }, [])

  return (
    <FollowersPanelContext.Provider value={contextValue}>
      {children}
      {/*// @ts-expect-error*/}
      <FollowersPanel isOpen={open} onChange={onAddFollower} onDismiss={handleDismiss} project={project} />
    </FollowersPanelContext.Provider>
  )
}